import React, { useEffect, useRef } from "react";

const normalizeYear = (year: string) => year.replace(/[^0-9]/g, "");

const Timeline = ({
  activeYear,
  onYearClick,
}: {
  activeYear: string;
  onYearClick: (year: string) => void;
}) => {
  const years = [
    "1998",
    "1999",
    "2008",
    "2010",
    "2012 - 2015",
    "2018 - 2019",
    "2020",
    "2021",
    "2022",
    "2023",
  ];

  const containerRef = useRef<HTMLDivElement>(null);
  const activeRef = useRef<HTMLDivElement>(null);

  // Auto-scroll selected year to center on mobile
  useEffect(() => {
    if (containerRef.current && activeRef.current) {
      const container = containerRef.current;
      const active = activeRef.current;

      const containerWidth = container.offsetWidth;
      const activeWidth = active.offsetWidth;
      const scrollLeft =
        active.offsetLeft - (containerWidth / 2 - activeWidth / 2);

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [activeYear]);

  return (
    <div className="w-full py-4">
      <div
        ref={containerRef}
        className="flex overflow-x-auto lg:overflow-x-visible no-scrollbar justify-start lg:justify-center items-center w-full max-w-6xl mx-auto"
      >
        {years.map((year, index) => {
          const isActive = normalizeYear(activeYear) === normalizeYear(year);
          const isRange = year.includes("-");

          return (
            <React.Fragment key={index}>
              <div
                ref={isActive ? activeRef : null}
                className="flex-shrink-0 w-1/3 sm:w-auto flex justify-center items-center px-2 py-2 scroll-snap-align-center"
              >
                <button
                  onClick={() => onYearClick(year)}
                  className={`transition cursor-pointer whitespace-nowrap ${
                    isActive
                      ? `border-2 border-orange-500 text-orange-500 font-bold rounded-full ${
                          isRange ? "px-5 py-2" : "px-3 py-1"
                        }`
                      : "text-gray-400 hover:text-white px-3 py-1"
                  }`}
                >
                  {year}
                </button>
              </div>

              {/* Connector line works in both mobile + desktop */}
              {index < years.length - 1 && (
                <div className="h-0.5 bg-gray-600 relative mx-1 w-5 sm:flex-1 flex-shrink-0">
                  <div
                    className="h-0.5 absolute top-0 left-0 transition-all duration-300"
                    style={{ width: isActive ? "100%" : "0%" }}
                  ></div>
                </div>
              )}
            </React.Fragment>
          );
        })}

      </div>
    </div>
  );
};

export default Timeline;
